import { useRequest } from 'umi';
import { useCallback, useState } from 'react';

import { getAllSourceInfo } from '@/apis/source';

interface RequestParams {
  enableLoading: boolean;
}

const useGlobalRouterModel = () => {
  const [loading, setLoading] = useState(false);

  const { data: routerConfig = [], run: requestRouters } = useRequest(
    ({ enableLoading }: RequestParams = { enableLoading: true }) => {
      if (enableLoading !== false) {
        setLoading(true);
      }

      return getAllSourceInfo();
    },
    {
      formatResult: (res) => {
        return res.assetTypes;
      },
      onSuccess: () => {
        setLoading(false);
      },
      onError: () => {
        setLoading(false);
      },
      manual: true,
      throwOnError: true,
    },
  );

  const getCurSource = useCallback(
    (key: string) => {
      return routerConfig.find((r) => r.key === key);
    },
    [routerConfig],
  );

  return {
    routerConfig,
    requestRouters,
    getCurSource,
    loading,
  };
};

export default useGlobalRouterModel;
